import React, { Component, ErrorInfo, ReactNode } from "react";
import { useLocation } from "react-router-dom";

import { ErrorMessage } from "../../items/ErrorMessage";

interface ErrorBoundaryProps {
    children: ReactNode;
    showStack?: boolean;
}

export const ErrorBoundary: React.FunctionComponent<ErrorBoundaryProps> = (props: ErrorBoundaryProps) => {
    const location = useLocation();

    return (
        <ErrorBoundaryComponent key={location.pathname} showStack={props.showStack}>
            {props.children}
        </ErrorBoundaryComponent>
    );
};

interface ErrorBoundaryState {
    hasError: boolean;
    errorStack?: string;
    errorMessage?: string;
}

class ErrorBoundaryComponent extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    public static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return { hasError: true, errorStack: String(error.stack) };
    }

    public constructor(props: ErrorBoundaryProps) {
        super(props);

        this.state = { hasError: false, errorStack: undefined };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.info("Uncaught error:", error, errorInfo);
    }

    public render() {
        if (this.state.hasError) {
            return <ErrorMessage stack={this.state.errorStack} showStack={this.props.showStack} />;
        }

        return this.props.children;
    }
}
